import { render } from "./TradeCardGP.vue?vue&type=template&id=0db49cfd&scoped=true&ts=true"
import script from "./TradeCardGP.vue?vue&type=script&lang=ts"
export * from "./TradeCardGP.vue?vue&type=script&lang=ts"

import "./TradeCardGP.vue?vue&type=style&index=0&id=0db49cfd&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db49cfd"]])

export default __exports__